import React from "react";

const HviContentSv = () => {

    return (
        <div>
            <div className="mb-4">
                <h4 className="fw-bold mb-3">Ta hjälp av vårt test Hållbar Vardag Index, som hjälper dig att må bra och prestera hållbart.</h4>
                <p>På tolv frågor och cirka fem minuter kan du få en indikation på hur hållbar din vardag är. Frågorna är formulerade för att ge dig en sammantagen bild av hur du ligger till, och möjlighet att reflektera över vad som kan göra din vardag mer hållbar. Över tid kan du sedan följa hur du lyckas med att en mer hållbar livsstil och vardag.</p>
            </div>

            <div className="mb-4">
                <h4 className="fw-bold mb-3">Resultatet delas in i en röd-gul-grön skala enligt följande:</h4>
                <p><span className="bg-sy-red px-2 py-1 me-1 text-white rounded-2">Rött (12-24)</span>: Tyder på en ohållbar vardag och en riskfaktor för ohälsa – en riskposition. Du behöver göra något åt din situation för att inte riskera din hälsa.</p>
                <p><span className="bg-sy-yellow px-2 py-1 me-1 text-white rounded-2">Gult (25-59)</span>: Tyder på att delar av din vardag är ohållbar och att du pendlar mellan en risk- och friskposition. Genom att göra förändringar i din vardag kan du ta kommandot och göra tillvaron mer hållbar.</p>
                <p><span className="bg-dark-green px-2 py-1 me-1 text-white rounded-2">Grönt (60–72)</span>: Tyder på en hållbar vardag och är en friskfaktor för hälsa – en friskposition.</p>
                <p>Du kan känna dig trygg med att göra testet för dina svar behandlas helt konfidentiellt!</p>
            </div>
        </div>
    )

}

export default HviContentSv;